<template>
  <div style="width:100%;">
    <v-expansion-panel-content v-for="(item, i) in itemData" :key="i">
      <template v-slot:header>
        <span v-if="!!item.SourceDetail">
          <b>{{ $t('WaterQualityAnalyteLabResultUnitMismatchErrorModal.date') }}:</b>
          {{ item.SourceDetail.SampleDateTime | formatDate }}
          <b>{{ $t('WaterQualityAnalyteLabResultUnitMismatchErrorModal.site') }}:</b>
          {{ item.SourceDetail.SiteId }}
          <b>{{ $t('WaterQualityAnalyteLabResultUnitMismatchErrorModal.analyte') }}:</b>
          {{ item.SourceDetail.AnalyteName }}
        </span>
        <span v-else>
          {{ item.Message }}
        </span>
      </template>
      <v-layout row wrap class="error-detail-body" v-if="!!item.SourceDetail">
        <v-flex xs4 class="border-bottom border-right">{{ $t('WaterQualityAnalyteLabResultUnitMismatchErrorModal.cocCode') }}</v-flex>
        <v-flex xs8 class="border-bottom">{{ item.SourceDetail.CocCode }}</v-flex>
        <v-flex xs4 class="border-bottom border-right">{{ $t('WaterQualityAnalyteLabResultUnitMismatchErrorModal.labSampleId') }}</v-flex>
        <v-flex xs8 class="border-bottom">{{ item.SourceDetail.LabSampleId }}</v-flex>
        <v-flex xs4 class="border-bottom border-right">{{ $t('WaterQualityAnalyteLabResultUnitMismatchErrorModal.databaseSampleId') }}</v-flex>
        <v-flex xs8 class="border-bottom">{{ item.SourceDetail.SampleId }}</v-flex>
        <v-flex xs4 class="border-right">{{ $t('WaterQualityAnalyteLabResultUnitMismatchErrorModal.message') }}</v-flex>
        <v-flex xs8>{{ item.Message }}</v-flex>
      </v-layout>
    </v-expansion-panel-content>
  </div>              
</template>

<script>
import format from 'date-fns/format'
import {
  preciseDateTimeFormat,
} from '@/components/mixins/MomentUtil'
export default {
  filters: {
    formatDate(date) {
      return format(date, preciseDateTimeFormat)
    },
  },
  props: {
    itemData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    }
  },
}
</script>

<style scoped>
  .error-detail-body {
    padding: 12px 24px;
  }
  .border-bottom{
    border-bottom: 1px solid gray;
  }
  .border-right{
    border-right: 1px solid gray;
  }
</style>